// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_83-0";
export var optionCard = "_83-1";